export const CANCEL_TREATMENT_BUTTON = 'CANCEL_TREATMENT_BUTTON';
